module.exports = __webpack_public_path__ + "img/real_time_on.ae08239b.svg";